import { useGraphql } from 'utils/hooks/useGraphql';

import { FolderId, splitFolderContents } from 'modules/domains/foldering';
import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';

import { TreeViewQueryResponse } from 'ui/indexPages/folders/treeView';
import { useCampaignQueryContext } from '../campaignFolders/contexts/CampaignQueryContext';
import { GraphQLCampaign } from '../domainTypes';
import { GraphQLCampaignSubfolder } from '../types';
import { FetchCampaignFolderQuery, FetchFolderQueryResponse } from './useCampaignFolder';

enum ContentFilter {
  ContentItem = 'ContentItem',
  Subfolder = 'Subfolder',
}

/* Subfolders only: Due to the long-running queries (and timeouts) experienced when querying folders with a large number
 * ContentItems, it has been decided that we will (at least temporarily) only request Subfolders */

export const useTreeViewQuery = (folderId: FolderId): TreeViewQueryResponse => {
  const { rootFolderId } = useCampaignQueryContext();
  const { data } = useGraphql<FetchFolderQueryResponse>(FetchCampaignFolderQuery, {
    variables: {
      content: [ContentFilter.Subfolder],
      folderId,
      pagination: {
        limit: 1000,
        offset: 0,
      },
    },
    fetchPolicy: 'no-cache',
  });
  const [childFolders = [], childItems = []] = splitFolderContents<
    GraphQLCampaignSubfolder,
    GraphQLCampaign
  >(data?.campaignFolder?.content || [], GRAPHQL_TYPENAMES.CAMPAIGN);
  return {
    childFolders,
    childItems,
    folderData: data?.campaignFolder || {
      id: rootFolderId,
      name: '',
      ancestors: [],
    },
  };
};
